import React from 'react';
import { Redirect, Route } from 'react-router-dom';

export const AdminPackagePrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {

      return localStorage.getItem('user-native') ? (
        JSON.parse(localStorage.getItem('user-native')).userType === 0 ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: props.location }
            }}
          />
        )
      ) : (
        <Redirect
          to={{
            pathname: '/auth/login',
            state: { from: props.location }
          }}
        />
      );
    }}
  />
);
